import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  getTinhHinhXuLyDonCacDonVi: {
    url: `${API_URL}/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhHinhXuLyDonCacDonViCon: {
    url: `${API_URL}/theoDoiGiamSats/tinhHinhXuLyDonTaiCacDonViCon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeSoLieuDonCuTheoDonVi: {
    url: `${API_URL}/theoDoiGiamSats/thongKeSoLieuDonCuTheoDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeSoLieuDonCuTheoDonViCon: {
    url: `${API_URL}/theoDoiGiamSats/thongKeSoLieuDonCuTheoDonViCon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonDungHanTreHanTaiDonVi: {
    url: `${API_URL}/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTenDonViTaiDanhSachDungHanTreHan: {
    url: `${API_URL}/theoDoiGiamSats/layTenDonViTaiDanhSachDungHanTreHan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonDungHanTreHanTaiDonViXuatExcel: {
    url: `${API_URL}/theoDoiGiamSats/danhSachDonDungHanTreHanTaiDonVi/xuatExcel`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getPhanHe: {
    url: `${API_URL}/theoDoiGiamSat/phanHes`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLoaiDonThu: {
    url: `${API_URL}/theoDoiGiamSat/loaiDonThus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTypeTimKiem: {
    url: `${API_URL}/theoDoiGiamSat/ngayThangNams`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhHinhXuLyDonCacDonViTheoKy: {
    url: `${API_URL}/theoDoiGiamSatTheoKys/tinhHinhXuLyDonTaiCacDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonTaiDonVi: {
    url: `${API_URL}/theoDoiGiamSatTheoKys/danhSachDonTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/theodoigiamsat.js